import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="menu"
export default class extends Controller {

  mobtoggle() {
    document.getElementById("mobmenu").classList.toggle("hidden");
  }
}
